var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReasonForAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.846,
    viewBox: "0 0 14 12.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-heart_1_",
    "data-name": "icons8-heart (1)",
    className: "cls-1",
    d: "M12.15,3A4.186,4.186,0,0,0,9,4.463,4.186,4.186,0,0,0,5.85,3,3.85,3.85,0,0,0,2,6.85C2,9.77,5.438,12.6,6.4,13.493,7.5,14.522,9,15.845,9,15.845s1.5-1.323,2.6-2.352C12.562,12.6,16,9.77,16,6.85A3.85,3.85,0,0,0,12.15,3Zm-1.182,9.177c-.124.112-.232.209-.319.291-.526.49-1.147,1.052-1.648,1.5-.5-.449-1.123-1.012-1.648-1.5-.088-.082-.2-.18-.319-.291C6.038,11.279,3.4,8.893,3.4,6.85A2.453,2.453,0,0,1,5.85,4.4a2.785,2.785,0,0,1,2.04.916L9,6.5l1.11-1.184A2.808,2.808,0,0,1,12.15,4.4,2.453,2.453,0,0,1,14.6,6.85C14.6,8.893,11.962,11.279,10.968,12.177Z",
    transform: "translate(-2 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonForAppointment);
export default __webpack_public_path__ + "static/media/reason_for_appointment.7fa70112adbd4921afad182894ee4133.svg";
export { ForwardRef as ReactComponent };